import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildRoomEntityV2 } from "@youm-front/room/util/factory";
import {
  ROOMS_LIST_FEATURE_KEY,
  RoomsListState,
  roomsListAdapter
} from "../reducers";

const { selectAll } = roomsListAdapter.getSelectors();

const state = createFeatureSelector<RoomsListState>(ROOMS_LIST_FEATURE_KEY);

export const isLoading = createSelector(
  state,
  (state: RoomsListState) => state.isLoading
);

export const rooms = createSelector(state, (state: RoomsListState) =>
  selectAll(state).map((_) => buildRoomEntityV2(_))
);

export const pastRooms = createSelector(state, (state: RoomsListState) =>
  selectAll(state).map((_) => buildRoomEntityV2(_))
);
